import { api } from './api';

export const b2bRatesService = {
  async getAllPlans(): Promise<any> {
    const res = await api.get('/admin/b2b/plans');
    return res.data;
  },

  async createPlan(name: string): Promise<any> {
    const res = await api.post('/admin/b2b/plans', { name });
    return res.data;
  },

  async getPlanRates(planId: string | number): Promise<any> {
    const res = await api.get(`/admin/b2b/plans/${planId}/rates`);
    return res.data;
  },

  async updatePlanRates(planId: string | number, courierId: string | number, payload: any): Promise<any> {
    const res = await api.put(`/admin/b2b/plans/${planId}/rates/${courierId}`, payload);
    return res.data;
  },

  async addCharge(planId: string | number, courierId: string | number, payload: any): Promise<any> {
    const res = await api.post(`/admin/b2b/plans/${planId}/charges/${courierId}`, payload);
    return res.data;
  },

  async updateCharge(chargeId: string | number, payload: any): Promise<any> {
    const res = await api.put(`/admin/b2b/charges/${chargeId}`, payload);
    return res.data;
  },

  async deleteCharge(chargeId: string | number): Promise<any> {
    const res = await api.delete(`/admin/b2b/charges/${chargeId}`);
    return res.data;
  },

  async downloadRates(planId: string | number): Promise<Blob> {
    const res = await api.get(`/admin/b2b/plans/${planId}/download`, { responseType: 'blob' });
    return res.data;
  },

  async uploadAndReplaceRates(planId: string | number, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post(`/admin/b2b/plans/${planId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
  async downloadSampleRates(): Promise<Blob> {
    const res = await api.get('/admin/b2b/plans/download-sample', {
      responseType: 'blob'
    });
    return res.data;
  },

  async uploadNewPlanRates(planName: string, file: File): Promise<any> {
    const formData = new FormData();
    formData.append('name', planName);
    formData.append('file', file);
    const res = await api.post('/admin/b2b/plans/upload-new', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  },

  async getUserRateCards(userId: string | number): Promise<any> {
    const res = await api.get(`/b2b/users/${userId}/rate-cards`);
    return res.data;
  }
};
